import { makeStyles } from "@material-ui/core";
import { useSelector } from "react-redux";
import UtilService from "../../../../../../../helper/service";

const useStyles = makeStyles(() => ({
  xAxis5: {
    position: 'relative',
    '& > .line': {
      width: '2px',
      height: '100%',
      backgroundColor: '#212D40',
      opacity: 0.05,
    },
    '& > .label': {
      fontSize: 8.5,
      fontFamily: 'roboto-medium',
      color: '#8192A2',
      position: 'absolute',
      left: '50%',
      transform: 'translateX(calc(-50% - 3px))',
      display: 'none',
    },
    '&:nth-of-type(1), &:nth-of-type(5n+1)': {
      '& > .label': {
        display: 'block',
      },
      '& > .line': {
        opacity: 0.1,
      },
    }
  },
  xAxis10: {
    position: 'relative',
    '& > .line': {
      width: '2px',
      height: '100%',
      backgroundColor: '#212D40',
      opacity: 0.05,
    },
    '& > .label': {
      fontSize: 8.5,
      fontFamily: 'roboto-medium',
      color: '#8192A2',
      position: 'absolute',
      left: '50%',
      transform: 'translateX(calc(-50% - 3px))',
      display: 'none',
    },
    '&:nth-of-type(1), &:nth-of-type(10n+1)': {
      '& > .label': {
        display: 'block',
      },
      '& > .line': {
        opacity: 0.1,
      },
    }
  },
  linePanel: {
    display: 'flex',
    flexDirection: 'row',
    position: 'absolute',
    height: 'calc(200% - 40px)',
    overflow: 'hidden',
  },
}));


function BackgroundLines(props: any) {

  const classes = useStyles();
  const { getMaxWidth, graphType, allParticipants, live } = props;
  const width = getMaxWidth ? getMaxWidth : 1500;
  const { module4Settings, userPreferences } = useSelector((state: any) => state.creatorOnBoarding);
  const { module4Data } = userPreferences;
  const { session, analyze } = module4Data.value;
  const stimulus = analyze.stimulus;
  const { graphZoom } = module4Settings;
  const { session_type } = session;

  const start = 0;
  const graphMinimized = ((stimulus && stimulus.stimulus_video_length < 120 && session_type === 'ASYNC'));
  const unit = graphMinimized ? (15 / Math.pow(graphZoom, 2)) : 15;

  return (
    <div
      className={classes.linePanel}
      style={{
        width: width,
        marginTop: (graphType && graphType === 'LIVE') ? 30 : (allParticipants ? 15 : -25),
        height: allParticipants ? (live ? 230 : 300) : '200% - 40px)'
      }}
    >
      {width && Array(Math.floor(width / unit)).fill('').map((_, index) => (
        <div
          data-id={index}
          key={index}
          className={graphMinimized ? classes.xAxis5 : classes.xAxis10}
          style={{ minWidth: `calc(100% / ${width / unit})`, }}
        >
          <div className='label'>{UtilService.getTimeLabel(index / 15 * unit, graphZoom, start)}</div>
          <div className='line' />
        </div>
      ))}
    </div>
  );
}

export default BackgroundLines;